import { useEffect } from 'react';
import { Header, Footer, CTA } from '../components/StudioUI';
import { Hero } from '../components/Hero';
import { Work, Marquee } from '../components/Work';
import { Package, Process, FAQ } from '../components/Offer';
import { InquiryForm } from '../components/InquiryForm';

export default function Home() {
  useEffect(() => { document.title = 'Local Launch Studio — Your business, properly online. $299.'; }, []);
  return <div id="top"><a className="skip-link" href="#main" data-testid="skip-to-content">Skip to content</a><Header /><main id="main"><Hero /><Work /><Marquee /><Package /><Process /><FAQ /><InquiryForm /></main><Footer /><div className="mobile-inquiry"><span data-testid="mobile-price">Your website.<strong>$299 total.</strong></span><CTA testId="sticky-mobile-inquiry">Request my website</CTA></div></div>;
}